import { render, staticRenderFns } from "./ui.vue?vue&type=template&id=22a5db81"
import script from "./ui.vue?vue&type=script&lang=js"
export * from "./ui.vue?vue&type=script&lang=js"
import style0 from "./ui.vue?vue&type=style&index=0&id=22a5db81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports